import { Check } from "lucide-react";
import { formatPrice } from "@/lib/store-helpers";

export const IncludesList = ({ items, testId, className = "" }) => (
  <ul data-testid={testId} className={`space-y-2 ${className}`}>
    {items.map((item) => (
      <li key={item} className="flex items-start gap-3 text-sm text-black/75">
        <Check className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={1.5} />
        {item}
      </li>
    ))}
  </ul>
);

export const SingleVariant = ({ variant }) => (
  <div data-testid="single-variant" className="border-y border-black/15 bg-white px-4 py-6 sm:px-5">
    <p className="text-[13px] font-medium uppercase tracking-[0.14em]">{variant.name}</p>
    <p className="mt-1 text-sm text-black/60">{variant.description}</p>
    <IncludesList items={variant.includes} testId={`variant-includes-${variant.id}`} className="mt-5" />
  </div>
);

export const VariantDetails = ({ product, selectedId, onSelect }) => (
  <div role="radiogroup" aria-label="Choose a package" className="flex flex-col border-t border-black/15">
    {product.variants.map((v) => {
      const active = v.id === selectedId;
      return (
        <div key={v.id} className={`border-b border-black/15 transition-colors duration-300 ${active ? "bg-white" : ""}`}>
          <button
            type="button"
            role="radio"
            aria-checked={active}
            data-testid={`variant-option-${product.slug}-${v.id}`}
            onClick={() => onSelect(v.id)}
            className="flex w-full items-start gap-4 px-4 py-5 text-left sm:px-5"
          >
            <span className={`mt-1.5 flex h-4 w-4 shrink-0 items-center justify-center border border-black ${active ? "bg-black" : ""}`}>
              {active && <span className="h-1.5 w-1.5 bg-white" />}
            </span>
            <span className="flex-1">
              <span className="flex items-baseline justify-between gap-4">
                <span className="text-[13px] font-medium uppercase tracking-[0.14em]">
                  {v.name}
                  {!v.whopUrl && <span className="ml-2 text-black/40">· Coming soon</span>}
                </span>
                <span className="font-serif text-2xl">{formatPrice(v.price)}</span>
              </span>
              <span className="mt-1 block text-sm text-black/60">{v.description}</span>
            </span>
          </button>
          {active && (
            <IncludesList items={v.includes} testId={`variant-includes-${v.id}`} className="fade-in px-4 pb-6 pl-12 sm:px-5 sm:pl-[3.25rem]" />
          )}
        </div>
      );
    })}
  </div>
);
